import { ApiService } from "../..";

export const bindPassword = (password: string) => {
  return ApiService.baseAction(
    "auth/bind_password",
    {
      data: { password },
    },
    "post"
  );
};
